export const getCountries = (state) => state.countries;
export const getUserLocation = (state) => state.userLocation;
export const getScreenType = (state) => state.screenType;
export const getCountry = (state) => state.country;
export const getLocations = (state) => state.locations;
